import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Tooltip } from '@mui/material';

interface VariablesSidebarCollapsedProps {
    onExpand: () => void;
}

export const VariablesSidebarCollapsed = ({ onExpand }: VariablesSidebarCollapsedProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: 1,
            minHeight: 0,
            flex: 1,
            justifyContent: 'flex-start',
        }}
    >
        <Tooltip title="Expand variables panel">
            <IconButton
                data-qa="variablesSidebarExpand"
                aria-label="Expand variables panel"
                size="small"
                onClick={onExpand}
            >
                <ChevronRightIcon />
            </IconButton>
        </Tooltip>
    </Box>
);
